const loyaltyErrorTypes = {
    MILESTONE_ALREADY_COMPLETED: 'MILESTONE_ALREADY_COMPLETED',
    BADGE_ALREADY_ACHIEVED: 'BADGE_ALREADY_ACHIEVED',
};

export default loyaltyErrorTypes;
